var map = {
	"./battery1_2x.png": 10203,
	"./battery2_2x.png": 96416,
	"./battery3_2x.png": 3937,
	"./battery4_2x.png": 64270,
	"./device_location.svg": 6479,
	"./located-gpsoff.png": 61054,
	"./located-gpson.png": 70070,
	"./lost-gpsoff.png": 47972,
	"./lost-gpson.png": 32534,
	"./phone-marker-special.png": 37987,
	"./phone-marker.png": 47298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11571;